module.exports = __webpack_public_path__ + "static/media/29ADMSPC8.b2f65b07.jpg";